module.exports = __webpack_public_path__ + "img/1557614065597095937.b4c8584a.png";